/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./intercom.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./intercom.component";
import * as i3 from "../../../../ej-shared/services/storage.service";
import * as i4 from "../../../../ej-shared/services/global.service";
var styles_IntercomComponent = [i0.styles];
var RenderType_IntercomComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_IntercomComponent, data: {} });
export { RenderType_IntercomComponent as RenderType_IntercomComponent };
export function View_IntercomComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_IntercomComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ej-intercom", [], null, null, null, View_IntercomComponent_0, RenderType_IntercomComponent)), i1.ɵdid(1, 114688, null, 0, i2.IntercomComponent, [i3.StorageService, i4.GlobalService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var IntercomComponentNgFactory = i1.ɵccf("ej-intercom", i2.IntercomComponent, View_IntercomComponent_Host_0, {}, {}, []);
export { IntercomComponentNgFactory as IntercomComponentNgFactory };
